<template>
  <v-app class="white" id="auth">
    <v-main>
      <v-container class="fill-height">
        <v-row class="fill-height">
          <v-col cols="12" lg="5" class="hidden-md-and-down">
            <v-card flat height="100%" rounded="xl">
              <v-img src="../../assets/login_background.webp" height="100%">
                <div class="left__text white--text text-h5">
                  <p class="text-uppercase mb-0">Portal</p>
                  <p class="text-uppercase">Administrativo</p>
                </div>
              </v-img>
            </v-card>
          </v-col>
          <v-col cols="12" lg="7" class="d-flex align-center">
            <v-row>
              <v-col cols="8" offset="2">
                <div
                  class="logo-container d-flex flex-column justify-center align-center"
                >
                  <img
                    src="../../assets/logo_av_securities.png"
                    alt="Logo Av"
                    class="logo"
                  />
                  <p class="logo-container__text silver--text">
                    ¡Bienvenido de nuevo! Por favor, ingrese a su cuenta.
                  </p>
                </div>
              </v-col>
              <v-col cols="10" offset="1">
                <ValidationObserver v-slot="{ invalid }">
                  <form @submit.prevent="handleSubmit">
                    <v-row>
                      <v-col cols="12">
                        <!--EMAIL -->
                        <ValidationProvider
                          name="Correo electrónico"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            label="Correo electrónico"
                            dense
                            v-model="userData.email"
                            placeholder="Correo electrónico"
                            :error-messages="errors[0]"
                            autofocus
                          />
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12">
                        <!-- PASSWORD -->
                        <ValidationProvider
                          name="Password"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="userData.password"
                            label="Contraseña"
                            placeholder="Contraseña"
                            :type="showPassword ? 'text' : 'password'"
                            @click:append="showPassword = !showPassword"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :error-messages="errors[0]"

                          />
                        </ValidationProvider>
                      </v-col>
                      <v-col
                        cols="12"
                        class="d-flex flex-row justify-end align-baseline"
                      >
                        <router-link
                          class="text-left"
                          :to="{ name: 'ForgotPassword' }"
                        >
                          ¿Olvidó su contraseña?
                        </router-link>
                      </v-col>
                      <v-col cols="12" class="d-flex justify-center">
                        <v-btn
                          color="secondary"
                          type="submit"
                          :loading="loading"
                          :disabled="invalid"
                          :elevation="0"
                        >
                          Login
                        </v-btn>
                      </v-col>
                    </v-row>
                  </form>
                </ValidationObserver>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SettingsService from '@/services/setting'
import MenuService from '@/services/menu'

export default {
  data() {
    return {
      userData: {
        email: '',
        password: '',
        remember: false
      },
      showPassword: false,
      recaptchaShow: false,
      sections: []
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('auth', ['user']),
  },
  methods: {
    ...mapActions('auth', ['signIn']),
    ...mapActions('menu', ['setMenu']),
    async handleSubmit() {
      try {
        await this.signIn(this.userData)
        if (this.user.admin) {
          await this.populateMenuSections()
          this.$router.push({
            name: 'Dashboard',
            params: { id: this.user.id }
          })
        } else {
          this.$dialog.notify.error('No autorizado')
        }
      } catch (e) {
        this.$dialog.notify.error(e)
      }
    },
    async populateMenuSections() {
      try {
        const { data } = await MenuService.fetch({ 'filter[type]': 'Admin' })
        this.sections = data.data
        this.setMenu(this.sections)
      } catch (e) {
        this.$dialog.notify.error(e)
      }
    },
    async getSettings() {
      const { data } = await SettingsService.fetch({
        'filter[key]': 'recaptcha'
      })
      this.recaptchaShow = data.data[0].value
    }
  }
}
</script>
<style>
#auth label.v-label {
  transform: translateY(-18px) scale(.75);
}
</style>
<style scoped>
.logo {
  max-width: 350px;
}

.left__text {
  position: absolute;
  left: 20px;
  bottom: 20px;
}

.links a {
  font: normal normal normal 16px/27px 'Libre Franklin';
  letter-spacing: 0px;
  color: #00559e;
  opacity: 1;
  text-decoration: none;
}

.logo-container__text {
  margin-top: 20px;
  text-align: center;
  font: normal normal normal 18px/14px 'Libre Franklin';
  letter-spacing: 0px;
  color: #8990ad;
  opacity: 1;
}

.form label {
  font: normal normal normal 12px/15px 'Libre Franklin';
  letter-spacing: 0;
}

@media (max-width: 979px) {
  .logo-container__text {
    font: normal normal normal 16px/18px 'Libre Franklin';
  }
  .text-left {
    font: normal normal normal 12px/27px 'Libre Franklin';
  }
}
</style>
